import { Modal } from 'components-antd';
import styles from './styles.module.scss';
import KitsTemplateEditor, { KitsTemplateModel } from './KitsTemplateEditor';
import { useRef } from 'react';
import { Button } from 'antd';

interface KitsTemplateModalProps {
  open: boolean;
  onClose: () => void;
  onSave: (template: KitsTemplateModel) => void;
  onDelete?: () => void;
  initialValue?: KitsTemplateModel;
}

const initialTemplateValue: KitsTemplateModel = {
  html: '',
  css: '',
  templateMeta: {
    projectJSON: null,
  },
};

function KitsTemplateModal({
  open,
  onClose,
  onSave,
  onDelete,
  initialValue,
}: KitsTemplateModalProps) {
  const editorRef = useRef<any>(null);

  return (
    <Modal
      title={
        <span className={styles.headerTitle}>
          <span className={styles.headerText}>Dynamic KIT Email Template</span>
        </span>
      }
      open={open}
      onCancel={onClose}
      footer={null}
      width={'1350px'}
      className={styles.templateModal}
      centered
    >
      <div className={styles.templateModalContent}>
        <div className={styles.editorWrapper}>
          <KitsTemplateEditor ref={editorRef} value={initialValue || initialTemplateValue} />
        </div>
      </div>
      <div className={styles.templateModalFooter}>
        <Button className={styles.deleteButton} onClick={onDelete}>
          Delete Template
        </Button>
        <Button
          type="primary"
          className={styles.saveButton}
          onClick={async () => {
            if (editorRef.current) {
              const templateData = await editorRef.current.getTemplateData();
              onSave(templateData);
            }
          }}
        >
          Save Template
        </Button>
      </div>
    </Modal>
  );
}

export default KitsTemplateModal;
